namespace Queries {
    interface ICustomerCountryQuery
        extends IQueryFilter {

    }

    export class CustomerCountryQuery
        implements ITQueryInfo<Indexes.Customer, Entities.Customer, ICustomerCountryQuery, Entities.Customer> {

        private _repository: RavenDbClient;
        
        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async execute(context: ITQueryRequestContext<Indexes.Customer, Entities.Customer>) {

            const { results: results, stats: stats } = await this._repository.queryDocuments<Entities.Customer>("customers", "", {}, context.from, context.limit)

            return {
                docs: results,
                totalResults: stats.totalResults
            }
        }
        
    }
}